import { FC, useEffect } from 'react';
import { CommoditiesTemplate } from '../../templates';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import {
  deleteCommodity,
  fetchCommoditiesNonRecursive,
} from '../../../store/tradeAPI/commodity/reducers/commodity.slice';
import cn from 'classnames';
import styles from './CommoditiesPage.module.css';
import Spinner from '../../atoms/Spinner/Spinner';
import { NonRecursiveCommodityResponseDto } from '../../../store/tradeAPI/commodity/dto/response/non-recursive-commodity-response.dto';

interface CommoditiesPageProps {}

interface ListViewContent {
  key: string;
  value: string | null;
}
interface ListViewData {
  imageUrl: string | null;
  content: ListViewContent[];
  id: string;
}

const CommoditiesPage: FC<CommoditiesPageProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const onAddCommodityClick = () => {
    navigate(`/commodities/add`);
  };

  const { nonRecursiveCommodities: commodities, nonRecursiveStatus: status } =
    useSelector((state: RootState) => state.commoditySlice);

  const data: ListViewData[] = commodities
    ? commodities.map((commodity: NonRecursiveCommodityResponseDto) => ({
        imageUrl: commodity.image,
        content: [
          {
            key: 'Name',
            value: commodity.name,
          },
          {
            key: 'HsCode',
            value: commodity.hsCode,
          },
          ...(commodity.parentId !== '00000000-0000-0000-0000-000000000000'
            ? [
                {
                  key: 'Parent',
                  value: commodity.parentId,
                },
              ]
            : []),
        ],
        id: commodity.id,
      }))
    : [];

  useEffect(() => {
    dispatch(fetchCommoditiesNonRecursive());
  }, [dispatch]);

  const onEditClick = (id: string) => {
    navigate(`/commodities/edit/${id}`);
  };

  const onDeleteClick = async (id: string) => {
    await dispatch(deleteCommodity(id));
    dispatch(fetchCommoditiesNonRecursive());
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.commoditiesTemplateWrapper)}>
      <CommoditiesTemplate
        data={data}
        onAddCommodityClick={onAddCommodityClick}
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
      />
    </div>
  );
};

export default CommoditiesPage;
